import { render, staticRenderFns } from "./SpoiledRupee.vue?vue&type=template&id=61ebf8da&scoped=true&"
import script from "./SpoiledRupee.vue?vue&type=script&lang=js&"
export * from "./SpoiledRupee.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledRupee.vue?vue&type=style&index=0&id=61ebf8da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebf8da",
  null
  
)

export default component.exports